import {createReducer, on} from '@ngrx/store';
import {BelegFilterTableActions} from '../actions/beleg-filter-table.actions';
import {BelegFilterTableState} from '../../interfaces/beleg-filter-table-state.interface';
import {TableSettings} from '../../interfaces/table-setting.interface';
import {BelegFilterListColumn} from '../../modules/beleg-filter-dialog/table-row/table-row.columns';


const initialTableSettings: TableSettings = {
  _key: 'zahlungen-app-beleg-filter-table-settings-2026-03-30_1',
  _columns: [
    {id: BelegFilterListColumn.Status, name: 'Status', isActive: true, sortable: false},
    {
      id: BelegFilterListColumn.Belegtyp,
      name: 'Belegtyp',
      isActive: true,
      sortable: true,
      sortIds: {asc: 'VORGANGSARTASC', desc: 'VORGANGSARTDESC'},
      width: 115,
    },
    {
      id: BelegFilterListColumn.Partner,
      name: 'Kunde/Lieferant',
      isActive: true,
      sortable: true,
      sortIds: {asc: 'PARTNERBEZEICHNUNGASC', desc: 'PARTNERBEZEICHNUNGDESC'},
      overflow: 'ellipsis',
    },
    {
      id: BelegFilterListColumn.Belegdatum,
      name: 'Belegdatum',
      isActive: true,
      sortable: true,
      sortIds: {asc: 'DATUMASC', desc: 'DATUMDESC'},
    },
    {
      id: BelegFilterListColumn.Betrag,
      name: 'Betrag',
      isActive: true,
      sortable: true,
      sortIds: {asc: 'BETRAGASC', desc: 'BETRAGDESC'},
      alignCell: 'right',
      alignHeader: 'right',
    },
    {
      id: BelegFilterListColumn.BelegbucheinAusgang,
      name: 'Ein-/Ausgang',
      isActive: false,
      sortable: false,
    },
    {
      id: BelegFilterListColumn.Kommentar,
      name: 'Kommentar',
      isActive: false,
      sortable: false,
      overflow: 'ellipsis',
    },
    {
      id: BelegFilterListColumn.Actions,
      name: '',
      isActive: true,
      sortable: false,
      disableRowClick: true,
      width: 195,
    },
  ],
  _sortDirs: [],
  _sortParams: [],
};

export const initialBelegFilterTableState: BelegFilterTableState = {
  tableSettings: initialTableSettings,
};

export const belegFilterTableReducer = createReducer(
  initialBelegFilterTableState,

  on(
    BelegFilterTableActions.changeTableSettings,
    (state, action) => ({
      ...state,
      tableSettings: action.tableSettings,
    })),
);
